export default __webpack_public_path__ + "static/media/52.7e6ab7a0.jpg";